import _objectSpread from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";

var res = require('@/config.js');

import { onMounted, reactive, toRefs, ref, getCurrentInstance } from 'vue'; // 导入scrollReveal

import scrollReveal from 'scrollreveal'; // 导入配置的scroll

import retScroll from '@/utils/scroll.js'; // 导入详情介绍

import checkProject from '@/components/checkProject'; // 导入页尾

import theEnd from '@/components/theEnd';
export default {
  name: 'Home',
  components: {
    checkProject: checkProject,
    theEnd: theEnd
  },
  setup: function setup() {
    // 注册实例Vue2 this
    var _getCurrentInstance = getCurrentInstance(),
        proxy = _getCurrentInstance.proxy; // 操作Dom 使用数字计时


    var webPercentage = ref(null);
    var javaPercentage = ref(null);
    var linuxPercentage = ref(null); // 赋值

    var data = reactive({
      // 声明 scrollReveal组件
      scrollReveal: scrollReveal(),
      // 点击爱心状态
      loveState: false,
      // 防抖
      States: false,
      // 工作经历传值
      my_project_son: []
    }); // 状态位

    var state = reactive({
      // 弹出层
      showDialog: false
    }); // 下载简历

    var gotoCV = function gotoCV() {
      window.open(proxy.$t.my_CV);
    }; // 点击爱心


    var loveThis = function loveThis() {
      if (data.States) return;
      data.States = true;
      setTimeout(function () {
        data.States = false;
        data.loveState = !data.loveState;
      }, 1000);
      data.loveState = !data.loveState;
    }; // 下滑到关于我


    var gotoIntroduction = function gotoIntroduction() {
      var element = document.querySelector('.introduction');
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }; // 下滑到技能经历


    var gotoExperience = function gotoExperience() {
      var element = document.querySelector('.experience');
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }; // 下滑到项目


    var gotoProject = function gotoProject() {
      var element = document.querySelector('.my_project');
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }; // 下滑到结尾


    var gotoTheEnd = function gotoTheEnd() {
      var element = document.querySelector('.the_end');
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }; // 查看项目详情


    var checkProject = function checkProject(e) {
      data.my_project_son = e;
      state.showDialog = true; // console.log(state.showDialog)
    }; // 页面加载生命周期


    onMounted(function () {
      // // 启动scrollReveal的方法
      retScroll(data, state, webPercentage, javaPercentage, linuxPercentage);
      console.log(res);
    }); // 结构导出

    var dataOut = toRefs(data);
    return _objectSpread(_objectSpread({}, dataOut), {}, {
      state: state,
      gotoCV: gotoCV,
      webPercentage: webPercentage,
      javaPercentage: javaPercentage,
      linuxPercentage: linuxPercentage,
      gotoIntroduction: gotoIntroduction,
      gotoExperience: gotoExperience,
      gotoProject: gotoProject,
      checkProject: checkProject,
      gotoTheEnd: gotoTheEnd,
      loveThis: loveThis
    });
  }
};